module.exports = __webpack_public_path__ + "1124ebe0da437ffca78ab004a42da482.svg";